module.exports = __webpack_public_path__ + "static/homeBg-b26383a844b660d969471167fd80433f.png";